import { getErrorCodeFromUnknown } from "./ErrorParsers";

export enum PrismaErrors {
  StoredProcedureNotFound = "prisma/stored-procedure-not-found",
}

const prismaErrorCodes = new Set<string>(Object.values(PrismaErrors));

export function getPrismaErrorCode(error: unknown): PrismaErrors | undefined {
  const errorCode = getErrorCodeFromUnknown(error);
  if (!errorCode || !prismaErrorCodes.has(errorCode)) {
    return undefined;
  }

  return errorCode as PrismaErrors;
}
